import React, { useState, useEffect } from 'react';
import uuid from 'react-uuid';
import { PickupPoint } from '../../../../shared/map/models';
import styles from './PickupPointSelectionPanel.module.scss';
import { SellingSession } from '../../../selling-sessions/models';
import { PickupPointWithSellingSessionsDto } from '../../models/PickupPointWithSellingSessionsDto.model';

interface PickupPointSelectionPanelProps {
    pickupPointsWithSellingSessions: PickupPointWithSellingSessionsDto[];
    selectPickupPoint: any;
}

export default function PickupPointSelectionPanel({ pickupPointsWithSellingSessions, selectPickupPoint }: PickupPointSelectionPanelProps) {

    const [selectedPickupPoint, setSelectedPickupPoint] = useState<PickupPoint>();

    useEffect(() => {
        const pickupPointId = localStorage.getItem('pickupPointsFilter')?.trim();
        const selectedPickupPointFromLocalStorage = pickupPointsWithSellingSessions.find(point => point.pickupPointToReturn.id === pickupPointId)?.pickupPointToReturn;
        if (selectedPickupPointFromLocalStorage) {
            setSelectedPickupPoint(selectedPickupPointFromLocalStorage);
        }
    })

    const handlePickupPointClick = (pickupPoint: PickupPoint) => {
        if (pickupPoint !== undefined && pickupPoint.id !== undefined) {
            setSelectedPickupPoint(pickupPoint);
            localStorage.setItem('pickupPointsFilter', pickupPoint.id);
        }
    };

    useEffect(() => {
        selectPickupPoint(selectedPickupPoint);
    }, [selectedPickupPoint]);

    const checkIfIsSelected = (pickupPoint: PickupPoint) => pickupPoint.id === selectedPickupPoint?.id;

    return (
        <div className={styles.container}>
            {pickupPointsWithSellingSessions.map((pickupPointWithSessions, index) => (
                <div key={index} className={`${styles.single_point_panel} ${checkIfIsSelected(pickupPointWithSessions.pickupPointToReturn) ? styles.selected_pickup_point : ''}`}
                    onClick={() => { handlePickupPointClick(pickupPointWithSessions.pickupPointToReturn) }}>
                    <div className={styles.pp_header}>{`Punkt odbioru ${index + 1}`}</div>
                    <div className={styles.pp_header}>{`Adres odbioru:`}</div>
                    <div className={styles.address}>
                        <div className={styles.pp_name}>{pickupPointWithSessions.pickupPointToReturn.name}</div>
                        <div className={styles.pp_address}>{pickupPointWithSessions.pickupPointToReturn.address.streetName} {pickupPointWithSessions.pickupPointToReturn.address.buildingNumber}</div>
                        <div className={styles.pp_address}>{pickupPointWithSessions.pickupPointToReturn.address.postalCode} {pickupPointWithSessions.pickupPointToReturn.address.city}</div>
                    </div>
                    {pickupPointWithSessions.sellingSessionInfos.length > 0 && pickupPointWithSessions.sellingSessionInfos.map((s, sessionIndex) => {
                        const startOrderingDate = new Date(s.startOrderingDate);
                        const endOrderingDate = new Date(s.endOrderingDate);
                        const startPickupDate = new Date(s.startPickupDate);
                        const endPickupDate = new Date(s.endPickupDate);

                        return (
                            <div className={styles.sessions_container} key={sessionIndex}>
                                <div className={styles.pp_header}>Data odbioru:</div>
                                <div className={styles.date_container}>
                                    <div className={styles.pp_date}>
                                        od {startPickupDate.toLocaleDateString()} {startPickupDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                    <div className={styles.pp_date}>
                                        do {endPickupDate.toLocaleDateString()} {endPickupDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                </div>
                                <div className={styles.pp_header}>Składanie zamówienia:</div>
                                <div className={styles.date_container}>
                                    <div className={styles.pp_date}>
                                        od {startOrderingDate.toLocaleDateString()} {startOrderingDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                    <div className={styles.pp_date}>
                                        do {endOrderingDate.toLocaleDateString()} {endOrderingDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                </div>
                            </div>

                        );
                    })}
                </div>
            ))}
        </div>
    );
}
